import React from 'react'
import './index.css'
import { formatDate } from '../../../../configTools/dateFormat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import TableSkeleton from '../../../../components/tableskeleton'

const Index = ({List, search, onSearch,loading}) => {
  return (
    <div className='user_table_wrapper'>
      <div className='user_table_search'>
        <input
          value={search || ''}
          onChange={(e)=>onSearch(e.target.value)}
          placeholder='Search invoice, doctor, status, department...'
        />
        <div className='user_table_search_icon'>
          <FontAwesomeIcon icon={faSearch}/>
        </div>
      </div>
      <div className='user_table_container'>
        <div className='_table'>
          <div className='_thead'>
            <div className='_tr'>
              {/* Net Total hidden at the lab's request (commented out, not removed). Its 15% went
                  to Client (was 30%) so the row still fills the table. To restore: uncomment the
                  Net Total header, cell and skeleton entry below and set Client back to 30%. */}
              <div className='_th' style={{width:"10%"}}>Invoice</div>
              <div className='_th' style={{width:"45%"}}>Client</div>
              <div className='_th' style={{width:"15%"}}>Status</div>
              <div className='_th' style={{width:"15%"}}>Department</div>
              <div className='_th' style={{width:"15%"}}>Date</div>
              {/* <div className='_th' style={{width:"15%",textAlign:"end"}}>Net Total</div> */}
            </div>
          </div>
          <div className={'_tbody' + (loading && List.length > 0 ? ' nv-rows-loading' : '')}>
            {List.length > 0 &&
              List.map((item,index)=>{
                return(
                  <div className='_tr' style={{padding:"5px 0px"}} key={index}>
                    <div className='_td' style={{width:"10%"}}>OR{item.id}</div>
                    <div className='_td' style={{width:"45%"}}>{item.doctorname}</div>
                    <div className='_td' style={{width:"15%"}}>{item.statusname}</div>
                    <div className='_td' style={{width:"15%"}}>{item.departmentname}</div>
                    <div className='_td' style={{width:"15%", backgroundColor:item.ordercolor}}>
                      {formatDate(item.duedate)}
                    </div>
                    {/* <div className='_td' style={{width:"15%",textAlign:"end"}}>{item.nettotal}</div> */}
                  </div>
                )
              })
            }
            {loading && List.length <= 0 &&
              // Net Total's '15%' removed from the end while that column is hidden; was
              // ['10%','30%','15%','15%','15%','15%'].
              <TableSkeleton columns={['10%','45%','15%','15%','15%']} rows={5}/>
            }
            {!loading && List.length <= 0 &&
              <div className='table_nodata'>
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index
